<template>
	<div class="plombs_maker">
		<b-overlay :show="is_load" rounded="sm">
			<b-container fluid>
				<h1 class="title text-center pb-5 mt-5">Створення / Переміщення пломб</h1>
				<b-row class="doc_title">
					<b-col lg="6" xl="6" xs="12" sm="6">
						<b-container fluid>
							<b-row class="doc_title mt-3">
								<b-col sm="3">
									<label for="doc_title">Серія *</label>
								</b-col>
								<b-col sm="4">
									<b-form-input :state="is_valid_seria" v-model="form.seria" maxlength="30" id="doc_title" size="sm"></b-form-input>
									<b-form-invalid-feedback id="input-live-feedback">
										Потрібно заповнити серію
									</b-form-invalid-feedback>
								</b-col>
							</b-row>

							<b-row class="start_seria mt-3">
								<b-col sm="3">
									<label for="start_seria">Початок серії*</label>
								</b-col>
								<b-col sm="4">
									<b-form-input :state="is_valid_start" v-model="form.number_from" maxlength="30"
												  id="start_seria" size="sm"></b-form-input>
								</b-col>
							</b-row>

							<b-row class="doc_title mt-3">
								<b-col sm="3">
									<label for="end_seria">Кінець серії*</label>
								</b-col>
								<b-col sm="4">
									<b-form-input :state="is_valid_end" v-model="form.number_to" maxlength="30"
												  id="end_seria" size="sm"></b-form-input>
								</b-col>
							</b-row>

						</b-container>
					</b-col>

					<b-col lg="6" xl="6" xs="12" sm="6" class="border-left">
						<div class="user_add cursor-pointer fs-xxl" v-if="!obj_to_null(this.user)">
							<div class="add user" @click="add_user">
								<i title="" class="fa add_user fa-plus-square" data-type="delegate_users"></i>
								<span>Оберіть користувача</span>
							</div>
						</div>

						<div class="user_to_fire" v-else>
							<user_block v-if="obj_to_null(this.user)"
										:key="user.id"
										v-bind:can_del=true
										v-bind:del_triger="remove_fire_from_doc"
										v-bind:user="user">
							</user_block>
						</div>
					</b-col>
				</b-row>
			</b-container>
			<div class="button_block row mt-5 pb-5">



				<div class="next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3">

					<button class="btn btn-lg btn-block btn-outline-success waves-effect waves-themed"
							:disabled="!is_save_active"
							v-on:click="save('create')"
					>
						<span class="fal fa-download mr-1"></span>
						Створити
					</button>
					<b-form-text id="input-live-help" v-if="save_has_err">
						{{save_err_txt}}
					</b-form-text>
				</div>

				<div class="next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3">
					<button class="btn btn-lg btn-block btn-outline-info waves-effect waves-themed" :disabled="!is_move_active" v-on:click="save('move')">
						<span class="fal  fa-eject mr-1"></span>
						 Переміщення
					</button>
				</div>
			</div>
		</b-overlay>
	</div>
</template>

<script>


import user_block from "../../shared/user/user_block/user_block.vue";
import {createHelpers} from 'vuex-map-fields';

const {mapFields} = createHelpers({
	getterType: 'user/getUserField',
});


export default {
	name: "create",

	components : {
		user_block,
	},
	created() {
		console.log('created fire');

		EventBus.$on('selected_users', e => {
			if (e.uniq === this.uniq_u) {
				EventBus.$emit('close_u_filter');
				this.load_user_info(e.users[0]);
			}
		});

		EventBus.$on(this.remove_fire_from_doc, e => {
			this.user = {};
		});
	},
	data: function data() {
		return {
			save_has_err : false,
			save_err_txt : "",
			is_load : false,
			seria_exist : false,
			form: {
				seria: "",
				number_from: 1,
				number_to: 0,
			},
			uniq_u : 'fire_user_add',
			user : {},
			remove_fire_from_doc : 'remove_fire',
		};
	},
	methods : {
		add_user() {
			EventBus.$emit('load_users_filter', {
					uniq      : this.uniq_u,
					active: [],
				}
			);
		},

		clean_form () {
			this.user = {};
			this.form.seria = "";
			this.form.number_from = 1;
			this.form.number_to = 0;

		},


		async save(type) {

			this.is_load = true;
			if(type === 'create') {
				await api.put('/plombs/create', {
					"set_name": this.form.seria,
					"set_start": this.form.number_from,
					"set_end": this.form.number_to,
					"owner_id": this.user.id,
					"created_by": this.cur_user,
				}).then(({data}) => {
					this.clean_form();
					this.is_load = false;
					EventBus.$emit('show_toast', {err: "Operation Success", type: "success", title: "OK"})

				}).catch(err => {
					this.is_load = false;
					IMC_CORE.hideloading();
					EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
				});
			}

			if(type === 'move') {
				await api.post('/plombs/move', {
					"set_name": this.form.seria,
					"set_start": this.form.number_from,
					"set_end": this.form.number_to,
					"owner_id": this.user.id,
					"created_by": this.cur_user,
				}).then(({data}) => {
					if(data.status == "operation_success") {
						let resp = data.data;
						console.log(resp);
						EventBus.$emit('show_toast', {err: "Всього :" + resp.all_plombs + " Виконано :" + resp.moved_plombs, type: "success", title: "Переміщення виконано"})
					}

					this.is_load = false;
				}).catch(err => {
					this.is_load = false;
                    IMC_CORE.hideloading();
					EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
				});
			}
		},


		async check_seria() {
			console.log("perfom_check_seria",this.form);


			if(this.is_valid_check) {
				this.save_has_err = false;
				this.save_err_txt = "";
				this.seria_exist = false;

				await api.post('/plombs/validate_set',{
					"set_name": this.form.seria,
					"set_start" : this.form.number_from,
					"set_end" : this.form.number_to,
				})
                    .then(({data}) => {
					if(data.status == "operation_fail") {
						this.save_has_err = true;
						this.save_err_txt = data.message;
						this.seria_exist = true;
					}

				}).catch(err => {
					EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
				});
			}
		},

		async load_user_info(user) {
			IMC_CORE.showloading();

			await api.get('/user/'+ user.id)
				.then(({data}) => {
                    IMC_CORE.hideloading();
					if (data.status === "operation_success") {
                        this.user = data.data;
					} else {
						EventBus.$emit('show_toast', {err: data.message, type: "danger", title: data.status})
					}
				}).catch(err => {
                    IMC_CORE.hideloading();
					EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
				});
		},
	},

	watch : {
		"form.seria" : function (val) {
			this.check_seria();
		},


		"form.number_from" : function(val) {
			this.check_seria();
		},

		"form.number_to" : function(val) {
			this.check_seria();
		},

	},

	computed: {
		...mapFields({
			"cur_user" : "user.id"
		}),

		is_valid_check () {
			try {
				return this.is_valid_start && this.is_valid_end && this.is_valid_seria;
			}
			catch (e) {

			}

			return false;
		},
		is_move_active () {
			return this.is_require_parametr_set && this.seria_exist;
		},

		is_save_active () {
			return this.is_require_parametr_set && !this.save_has_err;
		},

		is_require_parametr_set() {
			try {
				return this.is_valid_start && this.is_valid_end && this.is_valid_seria && this.user.id > 0;
			}
			catch (e) {

			}

			return false;
		},


		is_valid_seria() {
			return this.form.seria.length > 1;
		},

		is_valid_start() {
			return this.form.number_from >= 1;
		},
		is_valid_end() {
			return this.form.number_to >= 1;
		}
	},

}
</script>

<style scoped>

</style>
